<template>
    <div>
        <ts-loading-banner :loading="loadingPreData">
            <ts-card-wrapper>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                        <span>{{ $t('eventManagement.eventName') }}</span>
                        <p class="pull-right kh-font">{{ edit_data.event_name || '-' }}</p>
                    </li>
                    <li class="list-group-item">
                        <span>{{ $t('eventManagement.eventLocation') }}</span>
                        <p class="pull-right kh-font">{{ edit_data.event_location || '-' }}</p>
                    </li>
                    <li class="list-group-item">
                        <span>{{ $t('eventManagement.startDate') }}</span>
                        <p class="pull-right kh-font">{{ edit_data.event_start_date || '-' }}</p>
                    </li>
                    <li class="list-group-item">
                        <span>{{ $t('eventManagement.endDate') }}</span>
                        <p class="pull-right kh-font">{{ edit_data.event_end_date || '-' }}</p>
                    </li>
                    <li class="list-group-item">
                        <span>{{ $t('eventManagement.eventDescription') }}</span>
                        <p class="pull-right kh-font">{{ edit_data.event_description || '-' }}</p>
                    </li>
                    <li class="list-group-item">
                        <attach-file-show :value="edit_data" />
                    </li>
                </ul>
            </ts-card-wrapper>
        </ts-loading-banner>
    </div>
</template>

<script>
import AttachFileShow from './attach-file-show.vue'
import { mapState, mapActions } from 'vuex'

export default {
    name: 'event-management-show',
    components: { AttachFileShow },
    data() {
        return {
            loadingPreData: false
        }
    },
    computed: {
        ...mapState('eventManagement', ['edit_data']),
    },
    async mounted() {        
        const eventId = this.$route.params.id
        if (eventId && (_.isEmpty(this.edit_data) || this.edit_data.event_mgt_id !== eventId)) {
            this.loadingPreData = true
            try {
                await this.find(eventId) 
            } catch (error) {
                console.error('Failed to load event:', error)
            } finally {
                this.loadingPreData = false
            }
        }
    },
    methods: {
        ...mapActions('eventManagement', ['find']),
    },
    beforeRouteLeave(to, from, next) {
        if (_.isEmpty(to.params)) {
            this.$store.commit('eventManagement/RESET_STATE')
        }
        next()
    }
}
</script>

<style scoped>
#cover-image img {
    object-fit: contain;
    width: 100%;
    height: 100%;
}

.list-group-item {
    border: none !important;
    padding: 10px 0;
    margin: 0;
    border-top: 1px solid #eee !important;
}

.list-group-item.address {
    border: none !important;
    padding-top: 2px;
}

.text-uppercase {
    text-transform: uppercase !important;
}

#img-frame {
    display: block;
    position: relative;
    margin: -19%;
}

#img-frame img {
    object-fit: contain;
    width: 25%;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    padding: 3px;
    margin: 0 auto;
}

table td {
    vertical-align: middle;
}

::-webkit-scrollbar {
    height: 8px;
    width: 3px;
    background: #ffff;
}

::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
    background: #b7b7b8;
}
</style>
